var serverPath = window.location.origin;
class PriceDataCtrl {
  constructor($scope, $http, UtilsService) {

    var self = this;

    self.UtilsService = UtilsService;

    self.state = {
      tebGraduate: false,
      wsbGraduate: false,
      discountCode: '',
      companyNip: '',
      isHideInstallments: false
    };
    self.sku = '';
    self.candidate = {};
    self.candidate.details = {};
    self.product = {};
    self.statics = {};
    self.data = {
      tuitionSystem: [],
      wsbGraduateSchool: [],
      keyForOneInstallments: ''
    };
    self.discountCodeStatus = 'unknown';
    self.companyNipCodeStatus = 'unknown';
    self.price = {
      numberOfInstallments: '',
      tuitionSystem: '',
      wsbGraduateSchool: 0,
      discountCode: '',
      companyName: '',
      companyNip: '',
      tebGraduate: 0
    };

    self.APIparams = function() {
      return {
        'citizenship': typeof this.candidate.details.citizenship !== 'undefined' ? this.candidate.details.citizenship : null,
        'secondCitizenship': typeof this.candidate.details.secondCitizenship !== 'undefined' ? this.candidate.details.secondCitizenship : null,
        'polesCard': typeof this.candidate.details.polesCard !== 'undefined' ? this.candidate.details.polesCard : null,
        'polesCardExpiryDate': typeof this.candidate.details.polesCardExpiryDate !== 'undefined' ? this.candidate.details.polesCardExpiryDate : null,
        'tuition': typeof this.candidate.details.tuition !== 'undefined' ? this.candidate.details.tuition : null,
        'installments': typeof this.candidate.details.installments !== 'undefined' ? this.candidate.details.installments : null
      };
    };

    self.init = function () {
      self.data.numberOfInstallments = window.installments;
      self.data.wsbGraduateSchool = window.wsbGraduateSchool;
      self.data.tuitionSystem = window.tuitionSystem;
      self.sku = window.sku;
      self.candidate = window.candidate;
      self.product = window.product;
      self.data.keyForOneInstallments = window.statics.oneTimePayment;

      if (typeof window.price === "object") {
        self.price = angular.merge(self.price, window.price);
      }

      if (typeof window.statics === "object") {
        self.statics = angular.merge(self.statics, window.statics);
      }

      if (self.price.wsbGraduateSchool === 1) {
        self.state.wsbGraduate = true;
      }

      if (self.price.tebGraduate === true) {
        self.price.tebGraduate = '1';
        self.state.tebGraduate = true;
      }

      if (self.price.discountCode) {
        self.state.discountCode = self.price.discountCode;
      }

      if (self.price.companyNip) {
        self.state.companyNip = self.price.companyNip;
      }
    };

    self.wsbGraduateChange = function () {
      self.price.wsbGraduateSchool = self.state.wsbGraduate ? true : false;
    };

    self.wsbGraduateChange();

    self.stripNip = function(){
      if (typeof self.price.companyNip !== 'undefined') {
        self.state.companyNip = self.state.companyNip.replace(/\D/g,'');
      }
    };

    self.checkDiscount = function (discountCode, e) {
      e.preventDefault();
      var params = self.APIparams();
      params.discountCode = discountCode;

      $http({
        method: 'GET',
        url: encodeURI('./api/payment/' + self.sku + '/get-price'),
        params: params
      }).then(
        function success(response) {
          if (typeof response.error_code == 'undefined') {
            self.discountCodeStatus = 'success';
            self.price.discountCode = self.state.discountCode;
          } else {
            self.discountCodeStatus = 'error';
            self.price.discountCode = '';
          }
        },
        function error(response) {
          self.discountCodeStatus = 'error';
          self.price.discountCode = '';
        }
      );
    };

    self.checkCompanyDiscount = function (companyNip, e) {
      e.preventDefault();
      var params = self.APIparams();
      params.companyNip = companyNip;

      $http({
        method: 'GET',
        url: self.UtilsService.getApiPath('api/payment/' + self.sku + '/get-price'),
        params: params
      }).then(
          function success(response) {
            if (response.data.price_first_installment) {
              self.companyNipCodeStatus = 'success';
              self.price.companyNip = self.state.companyNip;
            } else {
              self.companyNipCodeStatus = 'error';
              self.price.companyNip = '';
            }
          },
          function error(response) {
            self.companyNipCodeStatus = 'error';
            self.price.companyNip = '';
          }
      );
    };

    self.isDiscountInvalid = function ()
    {
      return self.discountCodeStatus === 'error';
    };

    self.isDiscountValid = function ()
    {
      return self.discountCodeStatus === 'success';
    };

    self.isCompanyNipInvalid = function ()
    {
      return self.companyNipCodeStatus === 'error';
    };

    self.isCompanyNipValid = function ()
    {
      return self.companyNipCodeStatus === 'success';
    };

    self.showWsbGraduate = function () {
      if ((self.product.isFirstLevel || self.product.isLongCycle) && self.candidate.details.isForeigner) {
        return false;
      }

      return true;
    };

    self.showWsbGraduateCity = function () {
      return self.showWsbGraduate() && self.state.wsbGraduate;
    };

    self.showTebGraduate = function () {
      if (!self.candidate.details.isForeigner && (self.product.isFirstLevel || self.product.isLongCycle)) {
        return true;
      }

      return false;
    };

    self.changeTutionSystem = function () {
      if (self.price.tuitionSystem == self.data.keyForOneInstallments) {
        self.price.numberOfInstallments = 0;
        self.state.isHideInstallments = true;
        self.changeNumberOfInstallments();
      } else {
        self.state.isHideInstallments = false;
      }
    };

    self.changeNumberOfInstallments = function() {
      $('.main-content').addClass('sidebar_charge-is-established');
    };

  }
}

PriceDataCtrl.$inject = ['$scope', '$http', 'UtilsService'];

export default PriceDataCtrl;
